import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Shield } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";

const Login = () => {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (ready && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="bg-paper min-h-screen">
      <Header activeCategory={null} onCategory={() => {}} />
      <main className="max-w-md mx-auto px-4 py-20">
        <div className="bg-surface border border-rule p-8 grain-overlay relative">
          <div className="overline-label text-signal flex items-center gap-2 mb-3">
            <Shield size={14} /> Secure Terminal
          </div>
          <h1 className="font-display text-3xl font-black text-ink tracking-tight">Editor Access</h1>
          <p className="font-body text-muted-ink mt-2">Authorized personnel only. Enter clearance credentials.</p>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label className="overline-label text-muted-ink block mb-2">Email</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-paper border border-rule px-4 py-3 font-mono2 text-sm text-ink focus:outline-none focus:border-signal"
                placeholder="admin@disclosure.com"
                required
              />
            </div>
            <div>
              <label className="overline-label text-muted-ink block mb-2">Password</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-paper border border-rule px-4 py-3 font-mono2 text-sm text-ink focus:outline-none focus:border-signal"
                placeholder="••••••••"
                required
              />
            </div>
            {error && <p data-testid="login-error" className="font-mono2 text-xs text-signal">// {error}</p>}
            <button
              data-testid="login-submit"
              type="submit"
              disabled={busy}
              className="w-full bg-signal text-white font-mono2 text-xs uppercase tracking-[0.2em] py-4 hover:opacity-90 disabled:opacity-50"
            >
              {busy ? "Authenticating…" : "Access Terminal"}
            </button>
          </form>

          <p className="font-mono2 text-[0.65rem] text-muted-ink mt-6 tracking-wider">
            DEMO: admin@disclosurejournal.com / disclose2026
          </p>
        </div>
      </main>
    </div>
  );
};

export default Login;
